import { render } from "./BuzzPostText.vue?vue&type=template&id=5a1e00e6&scoped=true"
import script from "./BuzzPostText.vue?vue&type=script&lang=js"
export * from "./BuzzPostText.vue?vue&type=script&lang=js"

import "./buzz-employee-link.scss?vue&type=style&index=0&id=5a1e00e6&lang=scss&scoped=true&external"
import "./BuzzPostText.vue?vue&type=style&index=1&id=5a1e00e6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a1e00e6"]])

export default __exports__